import { generateActions, generateSelectors, generateTypes } from "../util";

export const key = "services";

// fetch services
export const FETCH_SERVICES = generateTypes(key, "read");
export const [
  fetchServices,
  fetchServicesSuccess,
  fetchServicesError,
  fetchServicesBusy,
  fetchServicesPoll,
] = generateActions(FETCH_SERVICES);
export const [
  selectServices,
  selectServicesError,
  selectServicesBusy,
  selectServicesPoll,
  selectServicesRequest,
] = generateSelectors(FETCH_SERVICES);

// create model
export const CREATE_MODEL = generateTypes(key, "create");
export const [
  createModel,
  createModelSuccess,
  createModelError,
  createModelBusy,
] = generateActions(CREATE_MODEL);
export const [
  selectCreateModel,
  selectCreateModelError,
  selectCreateModelBusy,
  ,
  selectCreateModelRequest,
] = generateSelectors(CREATE_MODEL);
